import React from 'react'

const Footer = () => {
  return <footer className='mt-8 w-full py-8 px-6 bg-black text-white'>
    <p className='text-center'>&copy; Copyright <a href="http://github.com/daniel-dunsin">Daniel Dunsin</a> 2022</p>
  </footer>
}

export default Footer